import type { ActiveSquadPlayer } from "@repo/shared/api";

import { Tactic } from "../../../redux/tactics/tacticsSlice";
import axios from "../../api";

type ResponseType = {
  manager: {
    country: number;
    league: number;
  };
  squadName: string;
  tactic: Tactic;
  currentFormation: string;
  players: ActiveSquadPlayer[];
};

export const importSquad = async (): Promise<ResponseType> => {
  const res = await axios.get<Promise<ResponseType>>("/user-squads/active");
  return res.data;
};
